module.exports = __webpack_public_path__ + "img/profile.9562464c.svg";